<template>
  <div class="trash-container">
    <h2>回收站</h2>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped>
  .trash-container {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #999;
    font-size: 18px;
  }
</style>
